import React from 'react';
import { Link } from 'react-router-dom';


import './studio.css';
import './animations.css';
import useScrollAnimation from './hooks/useScrollAnimation';
import useScrollFade from './hooks/useScrollFade';

export default function Studio(){
  const [heroRef, heroVisible] = useScrollAnimation(0.3);
  const [studioRef, studioVisible] = useScrollAnimation(0.2);
  const [ qualitiesVisible] = useScrollAnimation(0.2);
  const [peopleRef, peopleVisible] = useScrollAnimation(0.2);
  const [testimonialRef, testimonialVisible] = useScrollAnimation(0.2);
  const [ctaRef, ctaVisible] = useScrollAnimation(0.2);
  const [ctaInnerRef, ctaInnerStyle] = useScrollFade({ inOffset: 0.25, outOffset: 0.25, translate: 28 });
  
  return (
  <main className="studio-page">
    <section className="studio-page-btw-studio-hero btw-studio-hero--center" ref={heroRef}>
      <div className="container" style={{maxWidth: '1200px', margin: '0 auto'}}>
        <div className="studio-page-btw-studio-hero-inner btw-studio-hero-inner">
          <div className="studio-page-btw-studio-hero-copy btw-studio-hero-copy">
            <div className={`studio-page-btw-studio-subtitle btw-studio-subtitle subtitle-animate ${heroVisible ? 'visible' : ''}`}>Discover Our Journey</div>
            <h1 className={`studio-page-btw-studio-hero-title btw-studio-hero-title hero-title-animate ${heroVisible ? 'visible' : ''}`}>The Vision<br/> That Drives Us</h1>
            <p className={`studio-page-btw-studio-hero-desc btw-studio-hero-desc description-animate ${heroVisible ? 'visible' : ''}`}>A closer look at the passion, principles,<br/> and people shaping our company.</p>
          </div>
        </div>
      </div>
    </section>

    <div className="studio-page-btw-studio-wrap btw-studio-wrap">

      
      <section className="studio-page-btw-studio btw-studio" ref={studioRef} style={{display: 'flex', alignItems: 'flex-start', margin:'36px'}}>
        
        <div className="studio-page-btw-studio-left btw-studio-left" style={{minWidth: '220px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
          <img src={process.env.PUBLIC_URL + '/DSC00530.JPG'} alt="Our Studio" className={`studio-page-btw-studio-image btw-studio-image fade-in-scale ${studioVisible ? 'visible' : ''}`} style={{width: '100%', marginTop: '24px', borderRadius: '6px', maxWidth: '400px', height: '500px'}} />
        </div>
        <div className={`studio-page-btw-studio-content btw-studio-content fade-in-up ${studioVisible ? 'visible' : ''}`} style={{flex: 1, margin: '24px 0 24px 48px'}}>
          <div className={`studio-page-btw-studio-subtitle btw-studio-subtitle subtitle-animate ${studioVisible ? 'visible' : ''}`}>Our Studio</div>
          <h1 style={{textAlign: 'left', fontSize: '2rem', fontWeight: '500', margin: '12px 0 18px 0', color: '#181816', lineHeight: '1.1', fontFamily: 'instrument serif, serif'}}>Evolution starts with design</h1>
          <p>
            <em>"A constant evolution and deep passion for design keeps us motivated."</em></p>
          <p>
            At <b>Between the Walls,</b> we believe interiors are not just about structures and décor, but about the lives lived within them. Based in Pune, our studio crafts <b> residential and commercial spaces </b>that flow naturally around the people who inhabit them - never the other way around.</p>
          <p>
            We see every project as an <b>individual expression</b> of our client’s personality. By deeply understanding your values, lifestyle, and artistic preferences, we create <b>personalized interiors</b> that are not only elegant and comfortable but also <b>eco-conscious</b> - aligned with the future of modern living.</p>
          <p>
            For <b>Abhishek,</b> design is the union of <b>art, psychology, and biology.</b> Our holistic approach means we go beyond surface aesthetics. We design with <b>light, sound, textures, and nature,</b> engaging all five senses to create environments that elevate the human experience.</p>
          <p>
            The result is a space that does more than look beautiful - it <b>feels alive.</b> A space where you and your family can thrive, connect, and create memories that last a lifetime.
          </p>
        </div>
      </section>

      <style>{`
        @media (max-width: 900px) {
          .studio-page-btw-studio {
            flex-direction: column !important;
            margin: 12px !important;
          }
          .studio-page-btw-studio-left {
            width: 100% !important;
            min-width: auto !important;
            margin-bottom: 24px !important;
          }
          .studio-page-btw-studio-left img {
            max-width: 100% !important;
            height: auto !important;
          }
          .studio-page-btw-studio-content {
            margin: 0 !important;
            flex: 1 !important;
          }
        }
      `}</style>

    </div>

      {/* Qualities grid */}

      <section className="btw-qualities">
        <div className="btw-qualities-grid">
          <article className={`btw-quality fade-in-up ${qualitiesVisible ? 'visible' : ''}`} style={{maxWidth: '500px'}}>
            
            <h3 className="btw-quality-title">PERSONALISATION</h3>
            <p>Every space we design is as unique as the people who live or work within it. We take time to understand your story, values, and aspirations, translating them into interiors that reflect your identity.</p>
          </article>

          <article className={`btw-quality fade-in-up ${qualitiesVisible ? 'visible' : ''}`} style={{maxWidth: '500px'}}>
            
            <h3 className="btw-quality-title">SUSTAINABILITY</h3>
            <p>Luxury and responsibility go hand in hand. We embrace eco-conscious practices, from thoughtful material selection to energy-efficient solutions, ensuring lighter footprints for tomorrow.</p>
          </article>

          <article className={`btw-quality fade-in-up ${qualitiesVisible ? 'visible' : ''}`} style={{maxWidth: '500px'}}>
           
            <h3 className="btw-quality-title">SENSORY DESIGN</h3>
            <p>True design is felt, not just seen. We design with all five senses in mind - the warmth of natural light, the texture of materials, and the acoustics that calm or energize.</p>
          </article>

          <article className={`btw-quality fade-in-up ${qualitiesVisible ? 'visible' : ''}`} style={{maxWidth: '500px'}}>
            
            <h3 className="btw-quality-title">HARMONY</h3>
            <p>We believe the most memorable spaces are those where function and beauty coexist in perfect balance, creating seamless environments that feel effortless and welcoming.</p>
          </article>
        </div>
      </section>
      {/* Our People Section */}
      <section className="btw-people" ref={peopleRef} style={{background: 'rgba(13,13,13,0.95)', padding: '64px 0 80px 0'}}>
        <div className={`btw-people-title subtitle-animate ${peopleVisible ? 'visible' : ''}`} style={{color: '#B8B7AA', fontFamily: 'var(--framer-font-family-subtitle)', marginBottom: '32px', marginLeft: '28px', textTransform: 'uppercase', }}>Our People</div>
        <div className="btw-people-grid" style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '28px', width: '94vw', maxWidth: '1280px', margin: '0 auto'}}>
          <div className={`btw-person fade-in-up ${peopleVisible ? 'visible' : ''}`}>
              <img src={process.env.PUBLIC_URL + '/dave.png'} alt="Abhishek A. Dave" className="btw-person-image" />
            <div className="btw-person-name">Abhishek A. Dave</div>
            <div className="btw-person-role">Founder & Principal Designer</div>
            <hr className="btw-people-hr" />
          </div>
          <div className={`btw-person fade-in-up ${peopleVisible ? 'visible' : ''}`}>
              <img src={process.env.PUBLIC_URL + '/pranay.png'} alt="Pranay Mehta" className="btw-person-image" />
            <div className="btw-person-name">Pranay Mehta</div>
            <div className="btw-person-role">Associate Designer</div>
            <hr className="btw-people-hr" />
          </div>
          <div className={`btw-person fade-in-up ${peopleVisible ? 'visible' : ''}`}>
              <img src={process.env.PUBLIC_URL + '/mane.png'} alt="Ajeenkya Mane" className="btw-person-image" />
            <div className="btw-person-name">Ajeenkya Mane</div>
            <div className="btw-person-role">Designer</div>
            <hr className="btw-people-hr" />
          </div>
        </div>
        <style>{`
          @media (max-width: 768px) {
            .btw-people {
              padding: 48px 12px 64px 12px !important;
              box-sizing: border-box !important;
            }
            .btw-people-title {
              margin-left: 0 !important;
              margin-right: 0 !important;
              margin-bottom: 28px !important;
              text-align: center !important;
              padding: 0 12px !important;
              box-sizing: border-box !important;
            }
            .btw-people-grid {
              grid-template-columns: 1fr !important;
              gap: 32px !important;
              width: 100% !important;
              max-width: 100% !important;
              padding: 0 12px !important;
              box-sizing: border-box !important;
              margin: 0 !important;
            }
            .btw-person {
              padding: 0 !important;
              text-align: center !important;
            }
            .btw-person-image {
              margin: 0 auto !important;
              display: block !important;
            }
            .btw-person-name {
              text-align: center !important;
            }
            .btw-person-role {
              text-align: center !important;
            }
          }
        `}</style>
      </section>
        {/* Testimonial */}
      <section className="btw-testimonial-section bg-neutral-900 py-12" ref={testimonialRef}>
          <div className="btw-testimonial-flex">
                         <script src="https://cdn.lordicon.com/lordicon.js"></script>
              
<lord-icon
    src="https://cdn.lordicon.com/fozsorqm.json"
    trigger="loop"
    delay="2000"
    colors="primary:#121331,secondary:#baa170"
    style={{width: '75px', height: '75px'}}>
</lord-icon>
              <div className={`btw-testimonial-label subtitle-animate ${testimonialVisible ? 'visible' : ''}`}>Testimonial</div>
              <div className="btw-testimonial-content">
                <p className={`btw-testimonial-text description-animate ${testimonialVisible ? 'visible' : ''}`}>
                  "Working with Between the Walls was an absolute delight. They understood our vision and transformed it into a workspace that truly represents who we are as a firm. The design strikes the right balance between professionalism and warmth, making it a place where our team feels motivated and our clients feel welcomed. Every detail was thoughtfully planned and flawlessly executed."
                </p>
                <div className={`btw-testimonial-author fade-in-up ${testimonialVisible ? 'visible' : ''}`}>Priyank @ Stratjuris</div>
              </div>
          </div>
          <div className="btw-testimonial-container w-full rounded-xl overflow-hidden shadow-lg">
            <img src={process.env.PUBLIC_URL + '/project1.png'} alt="Testimonial" className={`btw-testimonial-image fade-in-scale ${testimonialVisible ? 'visible' : ''}`} style={{maxWidth: '100%', borderRadius: '12px', objectFit: 'cover', display: 'block', margin: '0 auto'}} />
          </div>
      </section>


            {/* Get Started Section */}
            <section className="btw-getstarted-section bg-neutral-900 min-h-[60vh] flex flex-col justify-center items-center text-center" ref={ctaRef}>
              <div className="btw-getstarted-inner" ref={ctaInnerRef} style={ctaInnerStyle}>
                <div className={`text-neutral-400 font-mono mb-6 subtitle-animate ${ctaVisible ? 'visible' : ''}`} style={{fontSize: '0.8rem'}}>GET  STARTED</div>
                <h1 className={`text-5xl md:text-7xl font-bold text-[#181816] mb-8 leading-tight hero-title-animate ${ctaVisible ? 'visible' : ''}`}>TRANSFORM YOUR<br />VISION INTO REALITY</h1>
                <Link to="/letstalk" style={{textDecoration: 'none'}}>
                  <button className={`btw-cta fade-in-up ${ctaVisible ? 'visible' : ''}`} type="button"><span>LET'S TALK</span></button>
                </Link>
              </div>
            </section>
    </main>
  );
}
